import type { Playlist, PlaylistItem } from '../../types/playlist';

import { resolveMediaAgeRatingLabel } from './ageRating';
import { formatDuration, formatVideoSchedule } from './formatting';

export type VideoMetadataEntry = string | { type: 'ageRating'; label: string };

export const createVideoMetadata = (media: PlaylistItem, episodesLabel?: string): VideoMetadataEntry[] => {
  const metaData: VideoMetadataEntry[] = [];
  const duration = formatDuration(media.duration);
  const ageLabel = resolveMediaAgeRatingLabel(media);

  if (media.pubdate) media?.year ? metaData.push(media?.year) : metaData.push(String(new Date(media.pubdate * 1000).getFullYear()));
  if (!episodesLabel && duration) metaData.push(duration);
  if (episodesLabel) metaData.push(episodesLabel);
  if (media.genre) metaData.push(media.genre);
  if (ageLabel) metaData.push({ type: 'ageRating', label: ageLabel });
  if (media.rating && media.rating !== ageLabel) metaData.push(media.rating);
  if (media.resolution) metaData.push(media.resolution);

  return metaData;
};

export const createPlaylistMetadata = (playlist: Playlist, episodesLabel?: string): VideoMetadataEntry[] => {
  const metaData: VideoMetadataEntry[] = [];

  if (episodesLabel) metaData.push(episodesLabel);
  if (playlist.genre) metaData.push(playlist.genre as string);
  if (playlist.rating) metaData.push(playlist.rating as string);

  return metaData;
};

export const createLiveEventMetadata = (media: PlaylistItem, locale: string): VideoMetadataEntry[] => {
  const metaData: VideoMetadataEntry[] = [];
  const scheduled = formatVideoSchedule(locale, media.scheduledStart, media.scheduledEnd);
  const duration = formatDuration(media.duration);
  const ageLabel = resolveMediaAgeRatingLabel(media);

  if (scheduled) metaData.push(scheduled);
  if (duration) metaData.push(duration);
  if (media.genre) metaData.push(media.genre);
  if (ageLabel) metaData.push({ type: 'ageRating', label: ageLabel });
  if (media.rating && media.rating !== ageLabel) metaData.push(media.rating);

  return metaData;
};
